import React, { useState } from 'react';
import styles from './avatar.module.scss';
import classNames from 'classnames';

export interface AvatarProps {
    url?: string;
    altText?: string;
    className?: string;
    avatarImg: string;
}

export function Avatar({ url, altText, className, avatarImg }: AvatarProps) {
    const [src, setSrc] = useState<string>(url || avatarImg);

    return (
        <img className={classNames(styles.img, className)} src={src} alt={altText} onError={() => setSrc(avatarImg)} />
    );
}
